export const NotFoundPageStrings = {
  notFound: '404',
  title: 'We’re sorry, this page doesn’t exist',
  pageDoesNotExist: `Check that the URL is correct or return to the main menu.`,
}
